import React, { Component } from 'react'
import Tooltip from './Tooltip/Tooltip'

interface Props {
  text: string
  tooltip: string | null
  truncate?: true
}

export default class TextTooltip extends Component<Props> {
  static defaultProps = {
    text: ''
  }

  render () {
    const { text, tooltip, truncate } = this.props
    return tooltip
      ? <Tooltip text={tooltip} truncate={truncate}>
        {this.props.text}
      </Tooltip>
      : text
  }
}
